import { useState } from "react";
import "../../assests/Login.css";
import { App, Button } from "antd";
import { CopyrightOutlined, WindowsFilled } from "@ant-design/icons";
import Logo from "../../assests/TFS Logo.png";
import { Link } from "react-router-dom";
import { AxiosFirst, MSCLIENT_ID, MSLOGINURL } from "../../config/config";
import VerifyEmailMessage from "./VerifyEmailMessage";
import TemResetPassword from "./TemResetPassword";

// Import your existing MSAL instance
import { msalInstance } from "../../config/MsalConfig";

const loginRequest = { scopes: ["openid", "profile", "email"] }; // Scopes for SSO

const Login = () => {
    const { notification } = App.useApp();
    const [loader, setLoader] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [email, setEmail] = useState('');
    const [user_id, set_user_id] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [verify_email, set_verify_email] = useState(false);
    const [temporary_password, set_temporary_password] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(prev => !prev);
    };

    const LOGIN_ACCOUNT = async () => {
        setLoader(true);
        try {
            const formData = new FormData();
            formData.append("email", email);
            formData.append("password", password);

            const res = await AxiosFirst.post("login-view/", formData);

            if (res?.data?.status) {
                if (res?.data?.email_verified) {
                    set_verify_email(true);
                } else if (res?.data?.temporary_password) {
                    set_user_id(res?.data?.user_id);
                    set_temporary_password(true);
                } else {
                    window.location.href = "/";
                }
            } else {
                setError(res.data.error || "Login failed");
            }
        } catch (err) {
            console.log(err);
            setError("Network error");
        }
        setLoader(false);
    };

    const handleMicrosoftLogin = async () => {
        try {

            //  Microsoft popup login
            const loginResponse = await msalInstance.loginPopup(loginRequest);

            // console.log("Microsoft Response:", loginResponse);

            const idToken = loginResponse.idToken;
            // const account = loginResponse.account;

            //  Get access token silently
            // const tokenResponse = await msalInstance.acquireTokenSilent({
            //     account: account,
            //     scopes: loginRequest.scopes
            // });
            // console.log(idToken);
            // const accessToken = tokenResponse.accessToken;

            //  Send tokens to backend
            const res = await fetch(MSLOGINURL, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Authorization": "Bearer " + idToken,
                    "ms-client-id": MSCLIENT_ID,
                    "Content-Type": "application/json",
                },
                // body: JSON.stringify({
                //     access_token: accessToken,
                //     account: account
                // })
            });

            const data = await res.json();
            console.log(data);
            if (!data.status) {
                notification.error({
                    message: "Failded",
                    description: "You are not registered on the LMS. Please contact the administrator.",
                });
                return;
            }

            // Cookies already set by backend, reload
            window.location.reload();

        } catch (err) {
            notification.error({
                message: "Failded",
                description: err.message,
            });
            setLoader(false);
        }
    };


    return (
        <>
            {verify_email ? <VerifyEmailMessage /> : temporary_password ?
                <TemResetPassword user_id={user_id} set_temporary_password={set_temporary_password} /> :
                <div className="login-wapper">
                    <div className="login-form" style={{ marginTop: "70px", padding: "20px 50px 50px 50px" }}>
                        <div>
                            <img alt="logo" src={Logo} style={{ Width: "500px", height: "200px" }} />
                            <p style={{ color: "black",marginTop:"-50px",fontSize:"16px",fontWeight:"700" }}>Travel Food Services</p>
                        </div>

                        <p style={{marginTop:"-30px"}}>Enter your details to sign in to your account</p>
                        {error && <p style={{ color: "red", fontWeight: "bold" }}>{error}</p>}

                        {/*   <input
                            className="black-input"
                            placeholder="Email Address"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                        />
                        <div style={{ position: "relative" }}>
                            <input
                                type={showPassword ? "text" : "password"}
                                className="black-input"
                                placeholder="Password"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                            />
                            {showPassword ?
                                <EyeTwoTone className="password-eye" onClick={togglePasswordVisibility} /> :
                                <EyeInvisibleOutlined className="password-eye" onClick={togglePasswordVisibility} />
                            }
                        </div>
 
                        <Link to="/forget-password" className="lms-link right" style={{ position: "relative", top: "-18px", left: "145px", color: "#fff" }}>
                            Forgot Password?
                        </Link>
 
                        {loader ?
                            <Button type="primary" style={{ width: "100%", height: "42px" }}>
                                <Spin indicator={<LoadingOutlined spin />} style={{ color: "#FFF" }} size="small" />
                            </Button> :
                            <Button type="primary" onClick={LOGIN_ACCOUNT} style={{ width: "100%", height: "42px" }}>
                                Sign In
                            </Button>
                        } */}

                        {/* Microsoft / SSO Button */}
                        <Button
                            type="default"
                            onClick={handleMicrosoftLogin}
                            style={{ width: "100%", marginTop: "15px", height: "42px", color: "#1c1c1c", backgroundColor: "transparent" }}
                        >
                            <WindowsFilled style={{ fontSize: "18px" }} /> Sign in with Microsoft
                        </Button>
                    </div>

                    <div className="login-footer">
                        <div style={{ marginLeft: "15px" }}>
                            Copyright <CopyrightOutlined /> {new Date().getFullYear()} Travel Food Services
                        </div>
                        <div style={{ marginRight: "15px" }}>
                            {/* <Link to="#" className="lms-link" style={{  }}>Terms & Policies</Link> */}
                        </div>
                    </div>
                </div>
            }
        </>
    );
};

export default Login;